import { Grid, Stack } from "@mui/material";

import { AllSystemsStatistics } from "./AllSystemsStatistics";
import { ClientGoal } from "./ClientGoal";
import { MilestoneTimeline } from "./milestone/MilestoneTimeline";
import { MonthlyFlightsChart } from "./MonthlyFlightsChart";
import { SYSTEMS } from "../../../constants";
import { useState } from "react";

export const ContractOverview = ({ contract: { uuid, goal, statistics } }) => {
    const nonLiteralStatistics = statistics.filter(
        (statistic) => statistic.system !== SYSTEMS.LITERAL
    );

    const [selectedSystem, setSelectedSystem] = useState(
        nonLiteralStatistics.length > 1
            ? "All"
            : nonLiteralStatistics.length > 0
              ? nonLiteralStatistics[0].system
              : "Literal"
    );

    return (
        <Stack spacing={1} direction="row">
            <MilestoneTimeline contractUuid={uuid} />
            <Stack spacing={1}>
                <Grid container>
                    <Grid sx={{ mr: 2 }}>
                        {statistics.length > 0 && (
                            <AllSystemsStatistics
                                statistics={statistics}
                                selectedSystem={selectedSystem}
                                setSelectedSystem={setSelectedSystem}
                            />
                        )}
                    </Grid>
                    {goal && (
                        <Grid size={6}>
                            <ClientGoal goal={goal} />
                        </Grid>
                    )}
                </Grid>
                {nonLiteralStatistics.length > 0 && (
                    <MonthlyFlightsChart
                        statistics={nonLiteralStatistics}
                        selectedSystem={selectedSystem}
                    />
                )}
            </Stack>
        </Stack>
    );
};
